import * as process from 'process/browser';
export { process };
